// Уменьшаем картинку на 20%
export function initShowSlid (params)
{
    const heightPx = params.showSlid.style.height;
    const height = parseInt(heightPx);

    const newHeight = parseInt((height - (height * 20) / 100));
    params.showSlid.style.height = newHeight+'px';
}

// Карусель
export function initSlideOwlCarousel(params)
{
    $(params.showSliderCarousel).owlCarousel({
        loop : true, // Бесконечный скролл
        dots: false, // точки навигации
        nav: true, // Кнопки вперёд-назад
        margin: 10, // отступы по бокам
        lazyLoad: true,
        navText: ['<i class="icon-angle-left"></i>', '<i class="icon-angle-right"></i>'],
        responsive:{
            0:{
                items: 2
            },
            600:{
                items: 3
            },
            1000:{
                items: 5
            }
        }
    });
}

// Блок с навигацией по странице (tabs)
export function initBlocsNav(params)
{
    const navLi = params.blocsNav.querySelectorAll('.nav_tabs li');
    navLi.forEach((li) => {
        li.addEventListener('click', activeNav)
    });

    function activeNav(e) {
        const target = e.target;
        const ulNav = target.closest('.nav_tabs');
        const li = ulNav.querySelectorAll('li');

        li.forEach((link) => {
            link.classList.remove('active');
        });

        const targetLi = target.closest('li');
        targetLi.classList.add('active');
    }
}

// Отображение блока с картой
export function locationMapIncrease(params)
{
    const descriptionLoc = params.tabDescLocation.querySelector('.description_loc');
    const locationMap = params.tabDescLocation.querySelector('.location_map');
    const dbmImg = params.tabDescLocation.querySelector('.dbm_img');
    const locAddress = params.tabDescLocation.querySelector('.loc_address');

    if (!descriptionLoc && locationMap) {
        locationMap.style.width = 100+'%';
        locationMap.style.marginLeft = 0+'px';
    }

    if ((!dbmImg && !locAddress) && descriptionLoc) {
        descriptionLoc.style.width =  100+'%';
        locationMap.style.width =  0+'px';
        locationMap.style.marginLeft = 0+'px';
    }
}

// Адаптация колонок в блоке "Удобства в отеле"
export function adaptationColHotelAmenities(params)
{
    const itemCol = params.tabConvenienceHotel.querySelectorAll('.ch_item_col');
    const hotelItems = params.tabConvenienceHotel.querySelector('.сonven_hotel_items');

    if (itemCol.length === 2) {
        hotelItems.style.justifyContent = "flex-start";

        for (let i = 0; i < itemCol.length; i++) {
            if (i === 1) {
                itemCol[i].style.marginLeft = "20px";
            }
        }
    }
}

// Показываем и скрываем описание отзывов
export function showLatestReviews(e)
{
    e.preventDefault();
    const target = e.target;

    const lrItem = target.closest('.lr_item');
    const lrItemA = target.closest('.lr_item a');
    const lriText = lrItem.querySelector('.lri_text');
    lriText.classList.toggle('active');

    if (lriText.classList.contains('active')) {
        lrItemA.innerText = BX.message('LINK_COLLAPSE');
    } else {
        lrItemA.innerText = BX.message('LINK_MORE');
    }
}

// Выводим Отзывы об отеле на Ajax
export function setMoreReviewsResult(data)
{
    const targetContainer = this.latestReviews;
    const navPage = targetContainer.querySelector('.nav_page_count_ajax');
    navPage.remove();

    targetContainer.insertAdjacentHTML("beforeend", data);

    this.initLatestReviews();
    this.latestReviewsBtn();
}

// Отображаем форму "Оставить отзыв"
export function leaveFeedbackResultHtml (data)
{
    BX.adjust(this.leaveFeedback, {
        style: {display: 'block'},
        html: data,
    });

    // Рейтинг инициализаия
    const ratingWrapper = document.querySelector('.rating_wrapper');
    const ratingCont = ratingWrapper.querySelectorAll('.rating_cont');
    let i = 1;

    ratingCont.forEach((rating) => {
        const labels = rating.querySelectorAll('label');

        labels.forEach((label) => {
            // При загрузке вешаем checked на первый инпут
            if (i === 1) {
                const input = label.querySelector('input')
                input.checked = true;

                const rodLabel = input.closest('label');
                const svg = rodLabel.querySelector('svg');
                svg.classList.add('in');
            }

            label.addEventListener('click', eventRating);
            i++;
        });
        i = 1;
    })

    // rg_active
    function eventRating (e) {
        const target = e.target;

        if (target.checked) {
            const id = target.getAttribute('id');
            const ratingArea = e.target.closest('.rating_area');
            const labelsNode = ratingArea.querySelectorAll('label');
            const labels = Array.from(labelsNode);

            labels.forEach((label) => {
                const labSvg = label.querySelector('svg')
                labSvg.classList.remove('in');
            })


            for (let key in labels) {
                const label = labels[key];

                const svg = label.querySelector('svg');
                const atFor = label.getAttribute('for');

                svg.classList.add('in');

                if (atFor === id) {
                    break;
                }
            }
        }
    }

    const submit = this.leaveFeedback.querySelector('button.btn_review');
    BX.bind(submit, 'click', BX.proxy(this.eventBtnFormVerification, this));
}
